// Header chrome: contractor logo + name + deck name.

import type { SharePayload } from "../types.ts";

export function renderHeader(payload: SharePayload): HTMLElement {
  const header = document.createElement("header");
  header.className = "dm-header";

  const brand = document.createElement("div");
  brand.className = "dm-header__brand";

  if (payload.contractorLogoUrl) {
    const logo = document.createElement("img");
    logo.className = "dm-header__logo";
    logo.src = payload.contractorLogoUrl;
    logo.alt = `${payload.contractorName} logo`;
    logo.loading = "eager";
    logo.decoding = "async";
    brand.appendChild(logo);
  }

  const contractor = document.createElement("span");
  contractor.className = "dm-header__contractor";
  contractor.textContent = payload.contractorName;
  brand.appendChild(contractor);

  header.appendChild(brand);

  const deckName = document.createElement("h1");
  deckName.className = "dm-header__deck";
  deckName.textContent = payload.deckName;
  header.appendChild(deckName);

  return header;
}
